// extracted by mini-css-extract-plugin
export default {"container":"kEYl6SE7PTJ1n5fwCC1T","clickableBlock":"H_7HTzkBcqbAB0mj8RPY"};